import React, { Fragment, useContext} from 'react';
import Sidebar from "../../components/sidebar";
import {GlobalContext} from "../../handlers/GlobalContext";

const SidebarWrap = ({methods, countries, handleSubmit, currentState}) => {
    const [ gState, dispatch] = useContext(GlobalContext);
    let state = {
        qGeneric: '',
        qProduct: '',
        qProducer: '',
        qMethod: ( !!methods ? methods.map(()=>{ return false; }) : [] ),
        qCountry: ( !!countries ? countries.map(()=>{ return false; }) : [] )
    }

    if(!!currentState) {
        state = {
            qGeneric: currentState.qGeneric,
            qProduct: currentState.qProduct,
            qProducer: currentState.qProducer,
            qMethod: currentState.qMethod,
            qCountry: currentState.qCountry
        }
    }

    const handleChange = (queryField, fieldPosition, e) => {
        if(fieldPosition != -1){
            state[queryField][fieldPosition] = e.target.checked;
        } else {
            state[queryField] = e.target.value;
        }
    }

    const translate = (term, alt) => {
        return gState.locale.translation[term] || alt || term;
    }

    return (
        <Fragment>

            <form onSubmit={(e) => { e.preventDefault(); handleSubmit(state); } }>
                <Sidebar title={translate("search-title-generic","Generic name")}>
                    <div className="sidebar-search">
                        <input type="text" defaultValue = {state.qGeneric} placeholder={translate("search-placeholder-generic","Generic name ...")} onChange={handleChange.bind(handleChange, 'qGeneric', -1)} />
                    </div>
                </Sidebar>

                <Sidebar title={translate("search-title-product","Medicinal product")}>
                    <div className="sidebar-search">
                        <input type="text" defaultValue = {state.qProduct} placeholder={translate("search-placeholder-product","Product name...")} onChange={handleChange.bind(handleChange, 'qProduct', -1)} />
                    </div>
                </Sidebar>

                <Sidebar title={translate("search-title-manufacturer","Manufacturer")}>
                    <div className="sidebar-search">
                        <input type="text" defaultValue = {state.qProducer} placeholder={translate("search-placeholder-manufacturer","Manufacturer name...")} onChange={handleChange.bind(handleChange, 'qProducer', -1)} />
                    </div>
                </Sidebar>

                {/*<Sidebar title={"Forms"}>*/}
                    {/*{*/}
                        {/*pharmForms.map(form => (*/}
                            {/*<div className="custom-control custom-checkbox" key={form.key}>*/}
                                {/*<input type="checkbox" className="custom-control-input" id={'input_' + form.key} />*/}
                                {/*<label className="custom-control-label" htmlFor={'input_' + form.key}>{form.value}</label>*/}
                            {/*</div>*/}
                        {/*))*/}
                    {/*}*/}
                {/*</Sidebar>*/}

                <Sidebar title={translate("search-title-methods","Methods")}>
                    {
                        !!methods && methods.map((method,idx) => (
                            <div className="custom-control custom-checkbox" key={'chkb_' + method.preparationMethodId}>
                                <input type="checkbox" defaultChecked={state.qMethod[idx]} className="custom-control-input" id={'method_' + method.preparationMethodId} onChange={handleChange.bind(handleChange, 'qMethod', idx)} />
                                <label className="custom-control-label" htmlFor={'method_' + method.preparationMethodId}>{method.methodName}</label>
                            </div>
                        ))
                    }
                </Sidebar>

                <Sidebar title={translate("search-title-countries","Countries")}>
                    {
                        !!countries && countries.map((country,idx) => (
                            <div className="custom-control custom-checkbox" key={'chkb_country_' + country.countryId}>
                                <input type="checkbox" defaultChecked={state.qCountry[idx]} className="custom-control-input" id={'country_' + country.code} onChange={handleChange.bind(handleChange, 'qCountry', idx)} />
                                <label className="custom-control-label" htmlFor={'country_' + country.code}>{ translate("locale-country-" + country.code.toLowerCase(), country.longName) }</label>
                            </div>
                        ))
                    }
                </Sidebar>

                {/*<Sidebar title={"Newest post"}>*/}
                {/*<ul className="sidebar-post">*/}
                {/*{posts.slice(0, 3).map(post => (*/}
                {/*<li key={post.id}>*/}
                {/*<a href={process.env.PUBLIC_URL + "/blog-details"}>{post.title}</a>*/}
                {/*<span>{post.meta.postDate}</span>*/}
                {/*</li>*/}
                {/*))}*/}
                {/*</ul>*/}
                {/*</Sidebar>*/}

                <Sidebar>
                    <button type="submit">
                        {translate("search-button-search","Search")}
                    </button>
                </Sidebar>
            </form>
        </Fragment>
    );
};

export default SidebarWrap;